import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import { getProjects, Project } from 'utils/ProjectsUtils';
import MaterialTable from 'material-table';
import { Link } from 'react-router-dom';
import { useAppContext } from 'hooks/useAppContext';
import withAppStylesGrid from 'HOCs/withAppStyles';
import LaunchIcon from '@material-ui/icons/Launch';
import { useAuthContext } from 'hooks/useAuthContext';
import GetAppIcon from '@material-ui/icons/GetApp';
import { exportProjectInspections } from 'utils/ProjectsUtils';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';




let projectColumns = Project.columns;

const ProjectsGrid = () => {
  const theme = useTheme();
  const { updateCurrentModule } = useAppContext();
  const auth = useAuthContext();
  const [exporting, setExporting] = useState(false);
  const [exportingRowId, setExportingRowId] = useState(null);



  projectColumns.filter(r => r.title === "Load Project").length === 0 &&
    // add a rendered column for loading projects
    projectColumns.push({
      field: "Load Project",
      title: "Load Project",
      render: rowData => (
        <Link
          to={`/projects/${rowData.ProjectId}/Details`}
          style={{ textDecoration: 'none' }}
          tooltip="launch"
        >
          <LaunchIcon onClick={() => { updateCurrentModule('Details') }} color="action" />
        </Link>
      ),
      sorting: false,
      filter: false,
      align: 'center'
    });

  if (auth.role && auth.role.name === "Administrator") {
    projectColumns.filter(r => r.title === "Export").length === 0 &&
      projectColumns.push({
        field: "Export",
        title: "Export",
        render: rowData => (
          exportingRowId === rowData.ProjectId ? (
            <CircularProgress size={24} />
          ) : (
            <Tooltip title="Export Project Data">
              <GetAppIcon
                onClick={async () => {
                  setExportingRowId(rowData.ProjectId);
                  try {
                    await exportProjectInspections(rowData.ProjectId); // now waits for download trigger
                  } catch (e) {
                    console.error("Export failed", e);
                  } finally {
                    setExportingRowId(null);
                  }
                }}

                style={{ cursor: 'pointer' }}
                color="primary"
              />
            </Tooltip>
          )
        ),
        sorting: false,
        filter: false,
        align: 'center'
      });
  }


  // only re-render grid when theme or auth changes
  const WrappedGrid = withAppStylesGrid(MaterialTable,
    {
      theme,
      getRecords: getProjects,
      defaultFilters: auth.role && auth.role.name !== "Administrator" ? {
        SystemUserId_SystemUser: auth.systemUserId
      } : {}
    }
  );

  return (
    auth.role && <div s> <WrappedGrid
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
      columns={projectColumns}
      title="Projects"
    />
      <div style={{ minHeight: '35px' }}> </div>
    </div>
  )
};

export default ProjectsGrid;